import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import DownloadAppCta, {
  DOWNLOAD_APP_CTA_CLEARANCE_CLASS,
} from "@/components/mobile/DownloadAppCta";
import { useRootStore } from "@/state/RootStore";

const RedeemSuccessPage = observer(() => {
  const { t } = useTranslation();
  const store = useRootStore();
  const profileRoute = store.mainAppStore.profilePersistedComplete
    ? "/profile"
    : "/create-profile";

  return (
    <main
      className={`flex min-h-screen w-full flex-col items-center justify-center bg-[#F7F8F7] px-6 py-10 text-center ${DOWNLOAD_APP_CTA_CLEARANCE_CLASS}`}
    >
      <section className="flex w-full max-w-md flex-col items-center">
        <CheckCircle2 className="h-14 w-14 text-[#5DB075]" />
        <h1 className="mt-5 text-2xl font-bold text-zinc-950">
          {t("redeem.success_page_title")}
        </h1>
        <p className="mt-3 text-base leading-7 text-zinc-600">
          {t("redeem.success_page_body")}
        </p>
        <Link
          to={profileRoute}
          replace
          className="mt-8 text-sm font-medium text-[#4d9f63] underline-offset-4 hover:underline"
        >
          {t("redeem.back_to_profile")}
        </Link>
      </section>
      <DownloadAppCta />
    </main>
  );
});

export default RedeemSuccessPage;
